import React from 'react'
import * as Layout from '../../components/layout'
import * as Menu from '../../components/menu'

export const routes = [
  {
    action: () => import('./component'/* webpackChunkName:  "EventsPage" */)
      .then(({AdminEventsConnected}) => <Layout.HeaderOnlyLayout><AdminEventsConnected /></Layout.HeaderOnlyLayout>),
    path: Menu.ADMIN_REPORTS_URL,
  },
]



// WEBPACK FOOTER //
// ./src/pages/admin-reports/routes.tsx